import m from "../../../../geodata/es2015/region/world/southAmericaHigh";
window.am4geodata_region_world_southAmericaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/world/southAmericaHigh.js
// module id = null
// module chunks = 